import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CurrentUserTeamSelectors } from '@ninety/mobile/platform/state';

import { HeadlinesFilterField } from './headlines-state.actions';
import { HeadlinesStatusEnum } from './models';
import { GetHeadlinesQueryParams } from './models/get-headlines-query-params';
import { headlinesEntityAdapter, headlinesInitailState, HeadlinesStateModel } from './models/headlines-state.model';

export namespace HeadlinesSelectors {
  export const selectHeadlinesFeatureState = createFeatureSelector<HeadlinesStateModel>('page-headlines');

  export const selectHeadlinesEntities = createSelector(selectHeadlinesFeatureState, state => state?.headlines ?? []);

  const headerlinesSelectors = headlinesEntityAdapter.getSelectors();
  export const selectAll = createSelector(selectHeadlinesEntities, headerlinesSelectors.selectAll);

  export const selectFiltersSet = createSelector(selectHeadlinesFeatureState, state => state.filterSet);

  export const selectHeadlines = createSelector(selectHeadlinesFeatureState, state => state.headlines);

  export const selectHeadlinesCount = createSelector(selectHeadlinesFeatureState, state => state.headlinesCount);

  export const selectPageIndex = createSelector(selectHeadlinesFeatureState, state => state.pageIndex);

  export const selectPageSize = createSelector(selectHeadlinesFeatureState, state => state.pageSize);

  export const selectPagination = createSelector(selectPageIndex, selectPageSize, (pageIndex, pageSize) => ({
    pageIndex,
    pageSize,
  }));

  export const selectStatus = createSelector(selectHeadlinesFeatureState, state => state.statusFilter);

  export const selectIsArchived = createSelector(selectHeadlinesFeatureState, state => state.archived);

  export const selectIsCascadingMessage = createSelector(selectHeadlinesFeatureState, state => state.isCascadedMessage);

  export const selectIsLoading = createSelector(selectHeadlinesFeatureState, state => state.isLoading);

  export const selectIncludeDiscussed = createSelector(selectHeadlinesFeatureState, state => state.includeDiscussed);

  export const selectSortDirection = createSelector(selectHeadlinesFeatureState, state => state.sortDirection);

  export const selecSelectedtHeadline = createSelector(selectHeadlinesFeatureState, state => state.selectedHeadline);

  export const selectTeamsAsOptions = createSelector(CurrentUserTeamSelectors.selectTeams, teams => teams);

  export const selectSelectedTeam = createSelector(selectHeadlinesFeatureState, state => state?.teamId ?? '');

  export const selectDefaultTeamId = createSelector(selectHeadlinesFeatureState, state => state?.defaultTeamId ?? null);

  export const selectGETRequestParams = createSelector(
    selectPagination,
    selectSelectedTeam,
    selectIsArchived,
    selectStatus,
    selectIsCascadingMessage,
    selectIncludeDiscussed,
    selectSortDirection,
    (
      pagination,
      teamId,
      archived,
      status,
      isCascadedMessage,
      includeDiscussed,
      sortDirection
    ): GetHeadlinesQueryParams => ({
      ...pagination,
      teamId,
      archived,
      status,
      isCascadedMessage,
      includeDiscussed,
      sortDirection,
    })
  );

  export const selectFilters = createSelector(
    selectStatus,
    selectSelectedTeam,
    selectIsArchived,

    (status, teamId, showArchived) => {
      return { status, teamId, showArchived };
    }
  );

  export const selectActiveFilterChips = createSelector(
    selectFilters,
    selectDefaultTeamId,
    CurrentUserTeamSelectors.selectTeams,
    (filters, defaultTeamId, teams) => {
      const chips: { field: HeadlinesFilterField; key: string; value?: string }[] = [];

      if (filters.teamId !== defaultTeamId && filters.teamId !== '') {
        chips.push({
          field: 'teamId',
          key: 'Team',
          value: teams.find(t => t._id === filters.teamId)?.name ?? filters.teamId,
        });
      }

      if (filters.status !== headlinesInitailState.statusFilter) {
        chips.push({
          field: 'statusFilter',
          key: 'Status',
          value:
            filters.status === HeadlinesStatusEnum.all
              ? 'All'
              : filters.status === HeadlinesStatusEnum.solved
                ? 'Solved'
                : 'Unsolved',
        });
      }
      if (filters.showArchived) {
        chips.push({ field: 'archived', key: 'Archived' });
      }

      return chips;
    }
  );
}
